import { cn } from '../lib/cn.js';

export interface SkeletonProps {
  className?: string;
}

/** Neutral placeholder block used while data loads. */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div className={cn('animate-pulse rounded-md bg-line-subtle', className)} aria-hidden="true" />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className={cn('h-3', index === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}

export function SkeletonCard({ className }: SkeletonProps) {
  return (
    <div className={cn('rounded-xl border border-line bg-surface p-[18px]', className)}>
      <Skeleton className="mb-3 h-4 w-1/2" />
      <Skeleton className="mb-2 h-3 w-1/3" />
      <Skeleton className="mb-3 h-1.5 w-full" />
      <Skeleton className="h-3 w-2/3" />
    </div>
  );
}
